var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wt2-producing-page wt2-sg"},[_c('producing-content',{attrs:{"video":_vm.video,"is-video-failed":_vm.isVideoFailed},on:{"stopListening":_vm.$_stopListening}}),_vm._v(" "),_c('producing-promo-banner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }